/**
 * Naming + categorization helpers — pure, verbatim from source
 * (component.js deriveName / detectCategory). No React, fully testable.
 */

const SKIP_LABELS: Record<string, number> = {
  mcp: 1, api: 1, www: 1, docs: 1, app: 1,
  developer: 1, dev: 1, sandbox: 1, staging: 1, portal: 1,
};

/** Derive a vendor display name from a URL (host-aware, skips infra labels). */
export function deriveName(url: string): string {
  if (!url) return 'New vendor';
  const s = url.trim().replace(/^https?:\/\//, '');
  const host = s.split('/')[0];
  if (!host.includes('.')) {
    const w = host.split(/[^A-Za-z0-9]/)[0];
    if (!w || w.length < 2) return 'New vendor';
    return w.charAt(0).toUpperCase() + w.slice(1);
  }
  const labels = host.split('.').filter(Boolean);
  const core = labels.slice(0, Math.max(1, labels.length - 1));
  while (core.length > 1 && SKIP_LABELS[core[0].toLowerCase()]) core.shift();
  const name = core[core.length - 1] || labels[0];
  return name.charAt(0).toUpperCase() + name.slice(1);
}

/** Ordered [keyword, category] rules — FIRST match wins (verbatim order). */
const CATEGORY_RULES: [string, string][] = [
  ['crm', 'CRM'], ['contact', 'CRM'], ['hubspot', 'CRM'], ['salesforce', 'CRM'],
  ['calendar', 'Scheduling'], ['schedul', 'Scheduling'], ['booking', 'Scheduling'], ['appointment', 'Scheduling'],
  ['slack', 'Messaging'], ['chat', 'Messaging'], ['sms', 'Messaging'], ['twilio', 'Messaging'], ['message', 'Messaging'],
  ['mail', 'Email'], ['gmail', 'Email'], ['email', 'Email'],
  ['pay', 'Payments'], ['stripe', 'Payments'], ['invoice', 'Payments'], ['billing', 'Payments'],
  ['support', 'Support'], ['ticket', 'Support'], ['zendesk', 'Support'], ['help', 'Support'],
  ['vet', 'Practice mgmt'], ['ezyvet', 'Practice mgmt'], ['practice', 'Practice mgmt'],
  ['analytic', 'Analytics'], ['report', 'Analytics'],
];

/** Guess a product category from a URL (defaults to 'CRM'). */
export function detectCategory(url: string): string {
  const s = (url || '').toLowerCase();
  for (const [k, v] of CATEGORY_RULES) if (s.includes(k)) return v;
  return 'CRM';
}

/** Random hex string of length n (used for webhook secrets). */
export function randHex(n: number): string {
  let s = '';
  const c = 'abcdef0123456789';
  for (let i = 0; i < n; i++) s += c[Math.floor(Math.random() * 16)];
  return s;
}

/** Two-letter initials from a name (fallback for ingested adapters). */
export function initialsOf(name: string): string {
  return name.replace(/[^A-Za-z0-9]/g, '').slice(0, 2).toUpperCase();
}
